
export function invalidAuth(props){
    logout()
    props.setError({ show: true, message: "Authentication failed. Please sign in again." })
}

export function logout(){
        localStorage.setItem("accessCode", 0);
        localStorage.setItem("accessToken", null);        
}